import React, { Component } from "react";
import {
  MDBRow,
  MDBCol,
  MDBContainer,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
} from "mdbreact";
import axios from "axios";
import MetaTags from "react-meta-tags";
import packkagee from "../../../package.json";
import "react-select-search/style.css";
import { admission } from "../ADMISSION";
export default class Insertpresent1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      REGISTER_ID: null,
      CITIZENT_LOGIN: null,
      PREFIX_LOGIN: null,
      FRISTNAME_LOGIN: null,
      MIDNAME_LOGIN: null,
      LASTNAME_LOGIN: null,
      FRISTNAMEEN_LOGIN: null,
      MIDNAMEEN_LOGIN: null,
      LASTNAMEEN_LOGIN: null,
      NICKNAME: null,
      GENDER_LOGIN: null,
      ddate: null,
      mdate: null,
      ydate: null,
      BDATE_DAY: null,
      BDATE_MONTH: null,
      BDATE_YEAR: null,
      BDATE_LOGIN: null,
      TELHOME_LOGIN: null,
      TELMOBILE_LOGIN: null,
      FACEBOOK_LOGIN: null,
      LINE_LOGIN: null,
      EMAIL_LOGIN: null,
      PROVINCE_ID: null,
      NATION_ID: null,
      RELIGION_ID: null,
      ORIGIN_ID: null,
      DEFORM_ID: null,
      BLOOD_ID: null,

      weight_study: null,
      height_study: null,
      waistline_study: null,

      selectyear: [],
      selectprovancy: [],
      selectnation: [],
      selectorigin: [],
      selectreligion: [],
      selectdeform: [],
      selectPREFIX_LOGIN: [],
    };
    this.selectday = [
      { value: "01", label: "1" },
      { value: "02", label: "2" },
      { value: "03", label: "3" },
      { value: "04", label: "4" },
      { value: "05", label: "5" },
      { value: "06", label: "6" },
      { value: "07", label: "7" },
      { value: "08", label: "8" },
      { value: "09", label: "9" },
      { value: "10", label: "10" },
      { value: "11", label: "11" },
      { value: "12", label: "12" },
      { value: "13", label: "13" },
      { value: "14", label: "14" },
      { value: "15", label: "15" },
      { value: "16", label: "16" },
      { value: "17", label: "17" },
      { value: "18", label: "18" },
      { value: "19", label: "19" },
      { value: "20", label: "20" },
      { value: "21", label: "21" },
      { value: "22", label: "22" },
      { value: "23", label: "23" },
      { value: "24", label: "24" },
      { value: "25", label: "25" },
      { value: "26", label: "26" },
      { value: "27", label: "27" },
      { value: "28", label: "28" },
      { value: "29", label: "29" },
      { value: "30", label: "30" },
      { value: "31", label: "31" },
    ];
    this.selectmonth = [
      { value: "01", label: "ม.ค." },
      { value: "02", label: "ก.พ." },
      { value: "03", label: "มี.ค." },
      { value: "04", label: "เม.ย." },
      { value: "05", label: "พ.ค." },
      { value: "06", label: "มิ.ย." },
      { value: "07", label: "ก.ค." },
      { value: "08", label: "ส.ค." },
      { value: "09", label: "ก.ย." },
      { value: "10", label: "ต.ค." },
      { value: "11", label: "พ.ย." },
      { value: "12", label: "ธ.ค." },
    ];
    this.selectblood = [
      { value: "-", label: "ไม่ระบุ" },
      { value: "A", label: "A" },
      { value: "B", label: "B" },
      { value: "O", label: "O" },
      { value: "AB", label: "AB" },
    ];
    this.selecsstblood = {
      name: "นาง",
      value: "005",
      label: "นาง",
      label2: "นาง",
    };
    this.handlePnameChange = this.handlePnameChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    // axios.get("https://git.kpru.ac.th/admission2017/student/loadpresent/" + localStorage.getItem("ID_LOGIN")).then((respone) => {
    axios
      .get(
        admission+"/student/loadpresent/" +
          localStorage.getItem("ID_LOGIN")
      )
      .then((respone) => {
        respone.data = respone.data.filter(({ REGISTER_STATUS }) => !(REGISTER_STATUS === "11"));
        this.setState({ REGISTER_ID: respone.data[0]["REGISTER_ID"] });
      });
    // axios.get("https://git.kpru.ac.th/admission2017/dashboard_profile/profile/"+localStorage.getItem("ID_LOGIN")).then((data) => {
    axios
      .get(
        admission+"/dashboard_profile/profile/" +
          localStorage.getItem("ID_LOGIN")
      )
      .then((data) => {
        this.setState({ CITIZENT_LOGIN: data.data[0]["CITIZENT_LOGIN"] });
        this.setState({ PREFIX_LOGIN: data.data[0]["PREFIX_LOGIN"] });
        this.setState({ FRISTNAME_LOGIN: data.data[0]["FRISTNAME_LOGIN"] });
        this.setState({ MIDNAME_LOGIN: data.data[0]["MIDNAME_LOGIN"] });
        this.setState({ LASTNAME_LOGIN: data.data[0]["LASTNAME_LOGIN"] });
        if (data.data[0]["FRISTNAMEENG_LOGIN"]) {
          this.setState({ FRISTNAMEEN_LOGIN: data.data[0]["FRISTNAMEENG_LOGIN"] });
          this.setState({ LASTNAMEEN_LOGIN: data.data[0]["LASTNAMEENG_LOGIN"] });
        } else {
          this.setState({ FRISTNAMEEN_LOGIN: data.data[0]["NAME_ENG"] });
          this.setState({ LASTNAMEEN_LOGIN: data.data[0]["LNAME_ENG"] });
        }
        this.setState({ NICKNAME: data.data[0]["NICKNAME"] });
        this.setState({ GENDER_LOGIN: data.data[0]["GENDER_LOGIN"] });
        this.setState({ BDATE_LOGIN: data.data[0]["BDATE_LOGIN"] });
        let explodbdate = data.data[0]["BDATE_LOGIN"].split("-");
        this.setState({ ddate: explodbdate[2] });
        this.setState({ mdate: explodbdate[1] });
        this.setState({ ydate: parseInt(explodbdate[0]) });
        this.setState({ TELHOME_LOGIN: data.data[0]["TELHOME_LOGIN"] });
        this.setState({ TELMOBILE_LOGIN: data.data[0]["TELMOBILE_LOGIN"] });

        this.setState({ FACEBOOK_LOGIN: data.data[0]["FACEBOOK_LOGIN"] });
        this.setState({ LINE_LOGIN: data.data[0]["LINE_LOGIN"] });
        this.setState({ EMAIL_LOGIN: data.data[0]["EMAIL_LOGIN"] });
        this.setState({ PROVINCE_ID: data.data[0]["PROVINCY_LOGIN"] });
        this.setState({ NATION_ID: data.data[0]["NATION_LOGIN"] });
        this.setState({ RELIGION_ID: data.data[0]["RELIGION_LOGIN"] });
        this.setState({ ORIGIN_ID: data.data[0]["RACE_LOGIN"] });
        this.setState({ DEFORM_ID: data.data[0]["DEFORM_ID"] });
        this.setState({ BLOOD_ID: data.data[0]["BLOOD_LOGIN"] });
        this.setState({ weight_study: data.data[0]["weight_study"] });
        this.setState({ height_study: data.data[0]["height_study"] });
        this.setState({ waistline_study: data.data[0]["waistline_study"] });
      });
    axios.get("https://mua.kpru.ac.th/frontend_tabian/graduate/ShowProvancy/").then((provancy) => {
      this.setState({ selectprovancy: provancy.data.DetailListLoad });
    });
    this.setState({
      selectnation: [
        { NATION_ID: "XX", NATION_NAME_TH: "ไม่มีสัญชาติ", NATION_NAME_ENG: "ไม่มีสัญชาติ" },
        { NATION_ID: "TH", NATION_NAME_TH: "ไทย", NATION_NAME_ENG: "THAILAND" },
        { NATION_ID: "CN", NATION_NAME_TH: "จีน", NATION_NAME_ENG: "CHINA" },
        {
          NATION_ID: "LA",
          NATION_NAME_TH: "ลาว",
          NATION_NAME_ENG: `LAO PEOPLE'S DEMOCRATIC REPUBLIC`,
        },
        { NATION_ID: "MY", NATION_NAME_TH: "มาเลเซีย", NATION_NAME_ENG: "MALAYSIA" },
        { NATION_ID: "MM", NATION_NAME_TH: "พม่า", NATION_NAME_ENG: "MYANMAR" },
        { NATION_ID: "KH", NATION_NAME_TH: "กัมพูชา", NATION_NAME_ENG: "CAMBODIA" },
      ],
    });
    axios
      .get(admission+"/student_insertpresent1/ref_religion/")
      .then((religion) => {
        this.setState({ selectreligion: religion.data });
      });
    axios
      .get(admission+"/student_insertpresent1/ref_origin/")
      .then((origin) => {
        this.setState({ selectorigin: origin.data });
      });
    axios
      .get(admission+"/student_insertpresent1/ref_deform/")
      .then((deform) => {
        this.setState({ selectdeform: deform.data });
      });
    axios.get(admission+"/dashboard/prefix").then((prefix) => {
      const options = prefix.data.map((d) => ({
        name: d.FULLNAME,
        value: d.PREFIX_NAME_ID,
        label: d.FULLNAME,
        label2: d.INITIALS,
      }));
      this.setState({ selectPREFIX_LOGIN: options });
      // this.setState({ selectPREFIX_LOGIN: prefix.data })
    });

    var newyear = new Date().getFullYear();
    var startyear = newyear - 16;
    var stopyear = newyear - 80;
    var o = 0;
    var y = [];
    while (startyear > stopyear) {
      y[o] = startyear;
      o++;
      startyear--;
    }
    const ssss = y.map((d) => ({
      value: d,
      label: d + 543,
      name: "ydate",
    }));
    this.setState({ selectyear: ssss });
  }

  handlePnameChange(event) {
    this.setState({ [event.target.name]: event.target.value });
    if (event.target.value === "003") {
      this.setState({ GENDER_LOGIN: "1" });
    } else if (event.target.value === "004" || event.target.value === "005") {
      this.setState({ GENDER_LOGIN: "2" });
    }
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    // var birthday = this.state.BDATE_LOGIN.split("-")
    let bodydata = {
      CITIZENT_LOGIN: this.state.CITIZENT_LOGIN,
      PREFIX_LOGIN: this.state.PREFIX_LOGIN,
      FRISTNAME_LOGIN: this.state.FRISTNAME_LOGIN,
      MIDNAME_LOGIN: this.state.MIDNAME_LOGIN,
      LASTNAME_LOGIN: this.state.LASTNAME_LOGIN,
      FRISTNAMEEN_LOGIN: this.state.FRISTNAMEEN_LOGIN,
      MIDNAMEEN_LOGIN: this.state.MIDNAMEEN_LOGIN,
      LASTNAMEEN_LOGIN: this.state.LASTNAMEEN_LOGIN,
      NICKNAME: this.state.NICKNAME,
      GENDER_LOGIN: this.state.GENDER_LOGIN,
      BDATE_DAY: parseInt(this.state.ddate),
      BDATE_MONTH: parseInt(this.state.mdate),
      BDATE_YEAR: parseInt(this.state.ydate) + 543,
      TELHOME_LOGIN: this.state.TELHOME_LOGIN,
      TELMOBILE_LOGIN: this.state.TELMOBILE_LOGIN,
      FACEBOOK_LOGIN: this.state.FACEBOOK_LOGIN,
      LINE_LOGIN: this.state.LINE_LOGIN,
      EMAIL_LOGIN: this.state.EMAIL_LOGIN,
      PROVINCE_ID: this.state.PROVINCE_ID,
      NATION_ID: this.state.NATION_ID,
      RELIGION_ID: this.state.RELIGION_ID,
      ORIGIN_ID: this.state.ORIGIN_ID,
      DEFORM_ID: this.state.DEFORM_ID,
      BLOOD_ID: this.state.BLOOD_ID,
      ID_LOGIN: localStorage.getItem("ID_LOGIN"),
    };
    // axios.post("https://git.kpru.ac.th/admission2017/student_insertpresent1/updatepresent/"+this.state.REGISTER_ID, bodydata).then((data) => {
    axios
      .post(
        admission+"/student_insertpresent1/updatepresent/" +
          this.state.REGISTER_ID,
        bodydata
      )
      .then((data) => {
        window.location.href = "/" + packkagee.name + "/Insertpresent2";
      });
  }

  render() {
    return (
      <>
        <MetaTags>
          <title>ข้อมูลประวัติส่วนตัว มหาวิทยาลัยราชภัฏกำแพงเพชร</title>
          <meta
            name="description"
            content="ข้อมูลประวัติส่วนตัว มหาวิทยาลัยราชภัฏกำแพงเพชร Kamphaeng Phet Rajabhat University"
          />
          <meta property="og:title" content="ข้อมูลประวัติส่วนตัว มหาวิทยาลัยราชภัฏกำแพงเพชร" />
          <meta property="og:image" content="../../public/favicon.ico" />
        </MetaTags>
        <br />
        <MDBContainer fluid>
          <h4>ข้อมูลรายงานตัว มหาวิทยาลัยราชภัฏกำแพงเพชร</h4>
          <form onSubmit={this.handleSubmit}>
            <MDBRow>
              <MDBCol lg="1" md="0" sm="0"></MDBCol>
              <MDBCol lg="10" md="12" sm="12">
                <MDBCard>
                  <MDBCardBody>
                    <MDBContainer fluid>
                      <MDBRow>
                        <MDBCol>
                          <MDBCardTitle>ข้อมูลประวัติส่วนตัว</MDBCardTitle>
                          <MDBCardText>
                            <span className="text-danger">* จำเป็นต้องกรอกข้อมูล</span>
                            <MDBRow>
                              <MDBCol lg="2" md="3" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="CITIZENT_LOGIN">
                                    รหัสเลขบัตรประชาชน <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="CITIZENT_LOGIN"
                                    name="CITIZENT_LOGIN"
                                    value={this.state.CITIZENT_LOGIN}
                                    disabled
                                    required
                                  />
                                </div>
                              </MDBCol>
                              <MDBCol lg="2" md="3" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="PREFIX_LOGIN">
                                    คำนำหน้า <span className="text-danger">*</span>
                                  </label>
                                  <select
                                    className="form-control"
                                    id="PREFIX_LOGIN"
                                    name="PREFIX_LOGIN"
                                    value={this.state.PREFIX_LOGIN}
                                    onChange={this.handlePnameChange}
                                    required
                                  >
                                    <option value="" hidden>
                                      ระบุคำนำหน้า
                                    </option>
                                    {this.state.selectPREFIX_LOGIN.map((data) => {
                                      return data.value === this.state.PREFIX_LOGIN ? (
                                        <>
                                          <option value={data.value} selected>
                                            {data.label}
                                          </option>
                                        </>
                                      ) : (
                                        <>
                                          <option value={data.value}>{data.label}</option>
                                        </>
                                      );
                                    })}
                                  </select>
                                  {/* <Select className="basic-single" isSearchable={true} id="PREFIX_LOGIN" name="PREFIX_LOGIN" options={this.state.selectPREFIX_LOGIN} defaultValue={this.state.optionprefix} onChange={this.handlePrenameChange} placeholder="ระบุคำนำหน้า" /> */}
                                </div>
                              </MDBCol>
                              <MDBCol lg="2" md="3" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="FRISTNAME_LOGIN">
                                    ชื่อ (ภาษาไทย) <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="FRISTNAME_LOGIN"
                                    name="FRISTNAME_LOGIN"
                                    value={this.state.FRISTNAME_LOGIN}
                                    onChange={this.handleChange}
                                    required
                                  />
                                </div>
                              </MDBCol>
                              <MDBCol lg="2" md="3" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="LASTNAME_LOGIN">
                                    นามสกุล (ภาษาไทย) <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="LASTNAME_LOGIN"
                                    name="LASTNAME_LOGIN"
                                    value={this.state.LASTNAME_LOGIN}
                                    onChange={this.handleChange}
                                    required
                                  />
                                </div>
                              </MDBCol>
                              <MDBCol lg="2" md="3" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="FRISTNAMEEN_LOGIN">
                                    ชื่อ (ภาษาอังกฤษ) <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="FRISTNAMEEN_LOGIN"
                                    name="FRISTNAMEEN_LOGIN"
                                    value={this.state.FRISTNAMEEN_LOGIN}
                                    onChange={this.handleChange}
                                    required
                                  />
                                </div>
                              </MDBCol>
                              <MDBCol lg="2" md="3" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="LASTNAMEEN_LOGIN">
                                    นามสกุล (ภาษาอังกฤษ) <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="LASTNAMEEN_LOGIN"
                                    name="LASTNAMEEN_LOGIN"
                                    value={this.state.LASTNAMEEN_LOGIN}
                                    onChange={this.handleChange}
                                    required
                                  />
                                </div>
                              </MDBCol>
                              <MDBCol lg="2" md="3" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="NICKNAME">
                                    ชื่อเล่น <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="NICKNAME"
                                    name="NICKNAME"
                                    value={this.state.NICKNAME}
                                    onChange={this.handleChange}
                                    required
                                  />
                                </div>
                              </MDBCol>
                              <MDBCol lg="1" md="3" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label">เพศ</label>
                                  <br />
                                  <div className="form-check-inline">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      id="GENDER_LOGIN1"
                                      name="GENDER_LOGIN"
                                      value="1"
                                      checked={this.state.GENDER_LOGIN === "1" ? true : false}
                                      onChange={this.handleChange}
                                    />
                                    <label className="form-check-label" for="GENDER_LOGIN1">
                                      {" "}
                                      ชาย
                                    </label>
                                  </div>
                                  <div className="form-check-inline">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      id="GENDER_LOGIN2"
                                      name="GENDER_LOGIN"
                                      value="2"
                                      checked={this.state.GENDER_LOGIN === "2" ? true : false}
                                      onChange={this.handleChange}
                                    />
                                    <label className="form-check-label" for="GENDER_LOGIN2">
                                      {" "}
                                      หญิง
                                    </label>
                                  </div>
                                </div>
                              </MDBCol>
                              <MDBCol lg="4" md="6" sm="12">
                                {/* <div className="form-outline mt-2">
                                                                <label className="form-label" for="BDATE_LOGIN">วันเดือนปีเกิด (ปี ค.ศ.) <span className="text-danger">*</span></label>
                                                                <input type="date" className="form-control" id="BDATE_LOGIN" name="BDATE_LOGIN" value={this.state.BDATE_LOGIN} onChange={this.handleChange} required />
                                                            </div> */}
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="bdate">
                                    วันเดือนปีเกิด<span className="text-danger">*</span>
                                  </label>
                                  <MDBRow>
                                    <MDBCol>
                                      <select
                                        className="form-control"
                                        id="ddate"
                                        name="ddate"
                                        onChange={this.handleChange}
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุวัน
                                        </option>
                                        {this.selectday.map((data) => {
                                          return data.value === this.state.ddate ? (
                                            <>
                                              <option value={data.value} selected>
                                                {data.label}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.value}>{data.label}</option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </MDBCol>
                                    <MDBCol>
                                      <select
                                        className="form-control"
                                        id="mdate"
                                        name="mdate"
                                        onChange={this.handleChange}
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุเดือน
                                        </option>
                                        {this.selectmonth.map((data) => {
                                          return data.value === this.state.mdate ? (
                                            <>
                                              <option value={data.value} selected>
                                                {data.label}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.value}>{data.label}</option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </MDBCol>
                                    <MDBCol>
                                      <select
                                        className="form-control"
                                        id="ydate"
                                        name="ydate"
                                        onChange={this.handleChange}
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุปี
                                        </option>
                                        {this.state.selectyear.map((data) => {
                                          return data.value === this.state.ydate ? (
                                            <>
                                              <option value={data.value} selected>
                                                {data.label}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.value}>{data.label}</option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </MDBCol>
                                  </MDBRow>
                                </div>
                              </MDBCol>
                              <MDBCol lg="2" md="6" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="TELHOME_LOGIN">
                                    เบอร์โทรศัพท์บ้าน{" "}
                                    <span className="text-danger">ไม่มีให้ใส่ - </span>
                                  </label>
                                  <input
                                    type="tel"
                                    className="form-control"
                                    id="TELHOME_LOGIN"
                                    name="TELHOME_LOGIN"
                                    value={this.state.TELHOME_LOGIN}
                                    onChange={this.handleChange}
                                    maxLength="15"
                                  />
                                </div>
                              </MDBCol>
                              <MDBCol lg="3" md="4" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="TELMOBILE_LOGIN">
                                    เบอร์มือถือที่สามารถติดต่อได้{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="tel"
                                    className="form-control"
                                    id="TELMOBILE_LOGIN"
                                    name="TELMOBILE_LOGIN"
                                    value={this.state.TELMOBILE_LOGIN}
                                    onChange={this.handleChange}
                                    maxLength="10"
                                    required
                                  />
                                </div>
                              </MDBCol>
                              {/* </MDBRow>
                                                    <MDBRow> */}
                              <MDBCol lg="4" md="4" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="FACEBOOK_LOGIN">
                                    ชื่อ Facebook{" "}
                                    <span className="text-danger">ไม่มีให้ใส่ - </span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="FACEBOOK_LOGIN"
                                    name="FACEBOOK_LOGIN"
                                    value={this.state.FACEBOOK_LOGIN}
                                    onChange={this.handleChange}
                                    required
                                  />
                                </div>
                              </MDBCol>
                              <MDBCol lg="4" md="4" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="LINE_LOGIN">
                                    Line ID <span className="text-danger">ไม่มีให้ใส่ - </span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="LINE_LOGIN"
                                    name="LINE_LOGIN"
                                    value={this.state.LINE_LOGIN}
                                    onChange={this.handleChange}
                                    required
                                  />
                                </div>
                              </MDBCol>
                              <MDBCol lg="4" md="4" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="EMAIL_LOGIN">
                                    E-mail <span className="text-danger">ไม่มีให้ใส่ - </span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="EMAIL_LOGIN"
                                    name="EMAIL_LOGIN"
                                    value={this.state.EMAIL_LOGIN}
                                    onChange={this.handleChange}
                                    required
                                  />
                                </div>
                              </MDBCol>
                              <MDBCol lg="2" md="4" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="NATION_ID">
                                    สัญชาติ <span className="text-danger">*</span>
                                  </label>
                                  <select
                                    className="form-control"
                                    id="NATION_ID"
                                    name="NATION_ID"
                                    onChange={this.handleChange}
                                    required
                                  >
                                    <option value="" hidden>
                                      ระบุสัญชาติ
                                    </option>
                                    {this.state.selectnation.map((data) => {
                                      return data.NATION_ID === this.state.NATION_ID ? (
                                        <>
                                          <option value={data.NATION_ID} selected>
                                            {data.NATION_NAME_ENG}
                                          </option>
                                        </>
                                      ) : (
                                        <>
                                          <option value={data.NATION_ID}>
                                            {data.NATION_NAME_ENG}
                                          </option>
                                        </>
                                      );
                                    })}
                                  </select>
                                </div>
                              </MDBCol>
                              <MDBCol lg="2" md="4" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="ORIGIN_ID">
                                    เชื้อชาติ <span className="text-danger">*</span>
                                  </label>
                                  <select
                                    className="form-control"
                                    id="ORIGIN_ID"
                                    name="ORIGIN_ID"
                                    onChange={this.handleChange}
                                    required
                                  >
                                    <option value="" hidden>
                                      ระบุเชื้อชาติ
                                    </option>
                                    {this.state.selectorigin.map((data) => {
                                      return data.ORIGIN_ID === this.state.ORIGIN_ID ? (
                                        <>
                                          <option value={data.ORIGIN_ID} selected>
                                            {data.ORIGIN_NAME}
                                          </option>
                                        </>
                                      ) : (
                                        <>
                                          <option value={data.ORIGIN_ID}>{data.ORIGIN_NAME}</option>
                                        </>
                                      );
                                    })}
                                  </select>
                                </div>
                              </MDBCol>
                              <MDBCol lg="2" md="4" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="RELIGION_ID">
                                    ศาสนา <span className="text-danger">*</span>
                                  </label>
                                  <select
                                    className="form-control"
                                    id="RELIGION_ID"
                                    name="RELIGION_ID"
                                    onChange={this.handleChange}
                                    required
                                  >
                                    <option value="" hidden>
                                      ระบุศาสนา
                                    </option>
                                    {this.state.selectreligion.map((data) => {
                                      return data.RELIGION_ID === this.state.RELIGION_ID ? (
                                        <>
                                          <option value={data.RELIGION_ID} selected>
                                            {data.RELIGION_NAME_TH}
                                          </option>
                                        </>
                                      ) : (
                                        <>
                                          <option value={data.RELIGION_ID}>
                                            {data.RELIGION_NAME_TH}
                                          </option>
                                        </>
                                      );
                                    })}
                                  </select>
                                </div>
                              </MDBCol>
                              <MDBCol lg="2" md="4" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="PROVINCE_ID">
                                    สถานที่เกิด (จังหวัด) <span className="text-danger">*</span>
                                  </label>
                                  <select
                                    className="form-control"
                                    id="PROVINCE_ID"
                                    name="PROVINCE_ID"
                                    onChange={this.handleChange}
                                    required
                                  >
                                    <option value="" hidden>
                                      ระบุสถานที่เกิด (จังหวัด)
                                    </option>
                                    {this.state.selectprovancy.map((data) => {
                                      return data.PROVINCE_ID === this.state.PROVINCE_ID ? (
                                        <>
                                          <option value={data.PROVINCE_ID} selected>
                                            {data.PROVINCE_NAME_TH}
                                          </option>
                                        </>
                                      ) : (
                                        <>
                                          <option value={data.PROVINCE_ID}>
                                            {data.PROVINCE_NAME_TH}
                                          </option>
                                        </>
                                      );
                                    })}
                                  </select>
                                </div>
                              </MDBCol>
                              <MDBCol lg="2" md="4" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="BLOOD_ID">
                                    หมู่เลือด <span className="text-danger">*</span>
                                  </label>
                                  <select
                                    className="form-control"
                                    id="BLOOD_ID"
                                    name="BLOOD_ID"
                                    onChange={this.handleChange}
                                    required
                                  >
                                    <option value="" hidden>
                                      ระบุหมู่เลือด
                                    </option>
                                    {this.selectblood.map((data) => {
                                      return data.value === this.state.BLOOD_ID ? (
                                        <>
                                          <option value={data.value} selected>
                                            {data.label}
                                          </option>
                                        </>
                                      ) : (
                                        <>
                                          <option value={data.value}>{data.label}</option>
                                        </>
                                      );
                                    })}
                                  </select>
                                </div>
                              </MDBCol>
                              <MDBCol lg="2" md="4" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="DEFORM_ID">
                                    ความพิการ <span className="text-danger">*</span>
                                  </label>
                                  <select
                                    className="form-control"
                                    id="DEFORM_ID"
                                    name="DEFORM_ID"
                                    onChange={this.handleChange}
                                    required
                                  >
                                    <option value="" hidden>
                                      ระบุความพิการ
                                    </option>
                                    {this.state.selectdeform.map((data) => {
                                      return data.DEFORM_ID === this.state.DEFORM_ID ? (
                                        <>
                                          <option value={data.DEFORM_ID} selected>
                                            {data.DEFORM_NAME}
                                          </option>
                                        </>
                                      ) : (
                                        <>
                                          <option value={data.DEFORM_ID}>{data.DEFORM_NAME}</option>
                                        </>
                                      );
                                    })}
                                  </select>
                                </div>
                              </MDBCol>
                            </MDBRow>
                          </MDBCardText>
                        </MDBCol>
                      </MDBRow>
                      {this.state.CITIZENT_LOGIN &&
                      this.state.PREFIX_LOGIN &&
                      this.state.FRISTNAME_LOGIN &&
                      this.state.LASTNAME_LOGIN &&
                      this.state.FRISTNAMEEN_LOGIN &&
                      this.state.LASTNAMEEN_LOGIN &&
                      this.state.NICKNAME &&
                      this.state.GENDER_LOGIN &&
                      this.state.ddate &&
                      this.state.mdate &&
                      this.state.ydate &&
                      this.state.TELMOBILE_LOGIN &&
                      this.state.NATION_ID &&
                      this.state.ORIGIN_ID &&
                      this.state.RELIGION_ID &&
                      this.state.PROVINCE_ID &&
                      this.state.BLOOD_ID &&
                      this.state.DEFORM_ID ? (
                        <>
                          <button type="submit" className="btn btn-primary btn-rounded btn-md mt-2">
                            บันทึกข้อมูล
                          </button>
                        </>
                      ) : (
                        <>
                          <button
                            type="submit"
                            className="btn btn-primary btn-rounded btn-md mt-2"
                            disabled
                          >
                            บันทึกข้อมูล
                          </button>
                        </>
                      )}
                    </MDBContainer>
                  </MDBCardBody>
                </MDBCard>
              </MDBCol>
              <MDBCol lg="1" md="0" sm="0"></MDBCol>
            </MDBRow>
          </form>
        </MDBContainer>
      </>
    );
  }
}
